import React from "react"
import PropTypes from "prop-types"
import Img from "gatsby-image"
import { Link, StaticQuery, graphql } from "gatsby"
import SocialLinks from "./socialLinks"
import { media, styled } from "./mediaCSS"
import MobileHeader from "./mobileHeader"

const MobilePWAHeader = styled.header`
  display: none;
  justify-content: space-between;
  background: darkblue;
  color: white;
  font-size: 30px;
  width: 100%;
  position: fixed;
  top: 0;
  height: 60px;

  ${media.mobilePWA`
    display: flex;

  `}
`

const DesktopTabletHeader = styled.header`
  min-height: 80px;
  font-family: "Oswald";
  display: flex;
  background: linear-gradient(#3668a4 0%, 40%, #204d84 40% 100%);
  ${media.mobile`
  display: none;
  `}
`

const HeaderSpacerLeft = styled.div`
  flex: 1 20%;
  display: none;
  ${media.desktop`
  display: block;
  `}
`

const HeaderSpacerRight = styled.div`
  flex: 1 20%;
  display: none;
  ${media.desktop`
  display: block;
  `}
`
const HeaderContent = styled.div`
  /* display: flex;
  flex: 3 100%; */
  width: 100%;
`

const HeaderTop = styled.div`
  flex: 1 0 0;
  height: 70px;
  display: flex;
`

const HeaderLeftTop = styled.div``

const HeaderRightTop = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-top: 6px;
  font-size: 20px;
  > a {
    color: white;
    padding: 0px 10px 0px 10px;
    text-decoration: none;
  }
`

const HeaderBottom = styled.div`
  display: flex;
  justify-content: flex-end;

  > a {
    color: white;
    text-decoration: none;
    padding: 2px 20px 7px 20px;
    border-radius: 5px 5px 0px 0px;
    text-transform: uppercase;
  }

  > a.active {
    background-color: rgba(0, 0, 0, 0.5);
  }
`

const Header = props => [
  <MobilePWAHeader>
    <div>left</div>
    <div>middle</div>
    <div>right</div>
  </MobilePWAHeader>,
  <MobileHeader></MobileHeader>,
  <DesktopTabletHeader>
    <HeaderSpacerLeft />
    <HeaderContent>
      <HeaderTop>
        <HeaderLeftTop>
          <Link to="/" title="Home">
            <StaticQuery
              query={graphql`
                query {
                  logo: file(relativePath: { eq: "logo.png" }) {
                    childImageSharp {
                      fixed(height: 70) {
                        ...GatsbyImageSharpFixed
                      }
                    }
                  }
                }
              `}
              render={data => [
                <Img
                  key="photoLogo"
                  className="topLogo"
                  fixed={data.logo.childImageSharp.fixed}
                />,
              ]}
            />
          </Link>
        </HeaderLeftTop>
        <HeaderRightTop>
          <Link to="/contact/">Contact Us</Link>
          <SocialLinks />
        </HeaderRightTop>
      </HeaderTop>
      <HeaderBottom>
        <Link activeClassName="active" to="/menu/">
          Menu
        </Link>
        <Link activeClassName="active" to="/specials/">
          Specials
        </Link>
        <Link activeClassName="active" to="/events/">
          Music
        </Link>
        <Link activeClassName="active" to="/location/">
          Location
        </Link>
        {/* 
        <Link activeClassName="active" to="/drinks/">
          Drinks
        </Link> */}
        <Link activeClassName="active" to="/catering/">
          Catering
        </Link>
        <Link activeClassName="active" to="/shuttle/">
          Shuttle
        </Link>
      </HeaderBottom>
    </HeaderContent>
    <HeaderSpacerRight />
  </DesktopTabletHeader>,
]

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
